// extracted by mini-css-extract-plugin
module.exports = {"inform-field-wrapper":"InformField_inform-field-wrapper__HP8jF"};